export default __webpack_public_path__ + "static/maps-netherlands-4804e0669aef4cb709f8b7a4e0594c68.png";